import { render } from "./DocumentClassList.vue?vue&type=template&id=55266476&scoped=true&ts=true"
import script from "./DocumentClassList.vue?vue&type=script&lang=ts"
export * from "./DocumentClassList.vue?vue&type=script&lang=ts"

import "./DocumentClassList.vue?vue&type=style&index=0&id=55266476&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55266476"]])

export default __exports__